import styled from '@emotion/styled'

const Image = styled.img`
    width: ${p => p.w};
    height: ${p => p.h};
`

export default Image